document.addEventListener('click', function(e) {
  var hdr = e.target.closest('.accs-acc-hdr');
  if (!hdr) return;

  var wrap = hdr.closest('.accs-wrap');
  if (!wrap) return;

  var hdrs  = wrap.querySelectorAll('.accs-acc-hdr');
  var bodies = wrap.querySelectorAll('.accs-acc-body');
  var wasOpen = hdr.classList.contains('is-open');

  /* Close all */
  hdrs.forEach(function(h) { h.classList.remove('is-open'); });
  bodies.forEach(function(b) {
    b.style.maxHeight = '0px';
    b.classList.remove('is-open');
  });

  /* Open clicked one if it was closed */
  if (!wasOpen) {
    var body = hdr.nextElementSibling;
    hdr.classList.add('is-open');
    body.classList.add('is-open');
    body.style.maxHeight = body.scrollHeight + 'px';
  }
});